<template>
    <div class="overflow-hidden"
        style="padding:0px 0px; margin-top:0px; background-color: #f2f7fa; border-radius: 10px;">
        <div class="flex justify-between mx-4">
            <div class="flex pt-2 pb-2">
                <el-select size="small" clearable v-model="selectTank" placeholder="Tank" class="mr-2"
                    @change="handleSelectChange" @visible-change="onTankDropdownVisible">
                    <el-option v-for="(status, key) in tankList" :key="key" :label="status.label"
                        :value="status.value" />
                    <div v-if="tankLoading" style="text-align: center; padding: 8px 0;">
                        <i class="el-icon-loading" style="font-size: 16px; color: #409EFF;"></i>
                    </div>
                </el-select>
                <el-select size="small" clearable v-model="selectProduct" @change="handleSelectChange" class="mr-2"
                    placeholder="Product">
                    <el-option v-for="(status, key) in productOptions" :key="key" :label="status.label"
                        :value="status.value">
                    </el-option>
                </el-select>
                <el-select size="small" clearable v-model="selectCustomer" @change="handleSelectChange" class="mr-2"
                    placeholder="Customer" v-if="this.userInfo.userType !== '2'">
                    <el-option v-for="(status, key) in customerList" :key="key" :label="status.label"
                        :value="status.value">
                    </el-option>
                </el-select>
            </div>
            <div class="flex pt-2 pb-2">
                <el-button plain @click="exportToExcel" size="small" class="pb-2" v-if="this.userInfo.userType !== '2'">
                    Export as Excel File
                </el-button>
                <el-button plain @click="importFromExcel" size="small" class="pb-2"
                    v-if="this.userInfo.userType !== '2'" type="secondary">
                    Import from Excel File
                </el-button>
            </div>
        </div>
        <div class="flex justify-center">
            <div class="w-full Comtable">
                <el-table :data="listData"
                    :header-cell-style="{ height: '55px', background: '#fff', 'border-bottom': '2px solid #D6D9E1' }"
                    :cell-style="getCellStyle" table-layout="auto" height="100%" @row-click="handleTableRowClick">
                    <el-table-column align="left" prop="tank" min-width="90" label="Tank" />
                    <el-table-column align="left" prop="tankFarm" min-width="150" label="Tank Farm" />
                    <el-table-column align="left" prop="product" min-width="150" label="Product" />
                    <el-table-column align="left" prop="customer" min-width="200" label="Customer">
                        <template #default="scope">
                            <div style="max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                :title="scope.row.customer">
                                <p v-for="value in scope.row.customer">{{ value }}</p>

                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="gov" min-width="100" label="GOV" />
                    <el-table-column align="left" prop="gsv" min-width="100" label="GSV" />
                    <el-table-column align="left" prop="metricTon" min-width="100" label="Metric Ton" />
                    <el-table-column align="left" prop="bbl" min-width="100" label="US BBL" />
                    <el-table-column align="left" prop="density" min-width="100" label="Density" />
                    <el-table-column align="left" prop="temp" min-width="100" label="Temperature (°C)" />
                </el-table>

            </div>

        </div>
        <div class="barging-pagination">
            <pagination :total="total" :page.sync="pageParams.pageNum" :limit.sync="pageParams.pageSize"
                @pagination="getList()"></pagination>
        </div>
        <pdf-view v-if="holdingCertUrl" :title="'Holding Cert'" :pdf-url="holdingCertUrl" v-model="showPdfView" />
    </div>
</template>

<script>
import PdfView from "@/components/common/pdf-view.vue";
import tabs from "@/components/tabs.vue";
import { getProductList, getTanksList } from "@/services";
import { createNewTransaction, exportExcel, generateHoldingCertPdf, getTankBookStockList, modifyTransaction } from "@/services/form";
import { formTankselect, getCSSList, importBookStockExcel } from "@/services/user";
import { mapState } from "vuex";

export default {
    name: "requests",
    components: { tabs, PdfView },
    data() {
        return {
            listData: [],
            selectProduct: "",
            selectTank: "",
            selectCustomer: "",
            pageParams: {
                pageNum: 1,
                pageSize: 50,
            },
            total: 0,
            operationData: {
                src: "",
                show: false,
            },
            createDialogVisible: false,
            holdingCertUrl: "",
            pdfDialogVisible: false,
            showPdfView: false,
            productOptions: [
            ],
            tankList: [],
            customerList: [],
            tankLoading: false,
            tankTotal: 0,
            tankPageParams: {
                pageNum: 1,
                pageSize: 10,
            },
        };
    },
    async mounted() {
        await this.loadTankList(true);
        this.getList();
        this.getProductList();
        this.loadCustomerList();
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    methods: {
        async loadCustomerList() {
            const res = await getCSSList(2);
            if (res.code === 200 && Array.isArray(res.data)) {
                this.customerList = res.data.map(item => ({
                    label: item.nickName,
                    value: item.nickName,
                }));
            } else {
                this.customerList = [];
            }
        },
        getProductList() {
            getProductList().then((res) => {
                this.productOptions = res.data.map(item => ({
                    label: item.productName,
                    value: item.productName
                }));
            });
        },
        getCellStyle({ rowIndex }) {
            if (rowIndex % 2 === 1) {
                return {
                    backgroundColor: "rgba(255,255,255,0.2)",
                };
            } else {
                return {
                    backgroundColor: "rgba(228,228,228,0.2)",
                };
            }
        },
        handleSelectChange() {
            this.pageParams.pageNum = 1;
            this.getList();
        },
        async getList() {
            const data = {
                ...this.pageParams,
                product: this.selectProduct || undefined,
                customer: this.selectCustomer || undefined,
                tank: this.selectTank || undefined,
            };

            try {
                const res = await getTankBookStockList(data);

                if (res.code === 200 && res.data && Array.isArray(res.data.rows)) {
                    this.listData = res.data.rows.map((item) => ({
                        id: item.id,
                        tankId: item.tankId,
                        tank: item.tankName,
                        tankFarm: item.tankFarm,
                        product: item.product,
                        customer: item.customer,
                        gov: item.gov,
                        gsv: item.gsv,
                        metricTon: item.metricTon,
                        bbl: item.bbl,
                        density: item.density,
                        temp: item.temp,
                    }));
                    this.total = res.data.total || 0;
                } else {
                    this.listData = [];
                    this.total = 0;
                }
            } catch (err) {
                console.error('Error loading table list:', err);
                this.listData = [];
                this.total = 0;
            }
        },
        getCellStyle({ rowIndex }) {
            if (rowIndex % 2 === 1) {
                return {
                    backgroundColor: "rgba(255,255,255,0.2)",
                };
            } else {
                return {
                    backgroundColor: "rgba(228,228,228,0.2)",
                };
            }
        },
        getStatusLabel(value) {
            const found = this.status.find(s => s.value === String(value));
            return found ? found.label : value;
        },
        getStatusColor(value) {
            switch (value) {
                case 1:
                    return { color: "#4CAF50" }; // Signed - Green
                case 2:
                    return { color: "#F44336" }; // Invalidated - Red
                default:
                    return { color: "#000000" }; // Default - Black
            }
        },
        noItemFound(row) {
            return row.bbl == undefined && row.density == undefined && row.gov == undefined && row.gsv == undefined && row.metricTon == undefined && row.product == undefined && row.temp == undefined
        },
        handleTableRowClick(row) {
            if (this.noItemFound(row)) {
                this.$router.push({
                    path: "/tankBookStock/index",
                    query: {
                        tank: row.tank,
                        tankFarm: row.tankFarm,
                        customer: row.customer,
                        pageStatus: 2,
                        tankId: row.tankId,
                    },
                });
                sessionStorage.setItem("pageStatus", 2);
                return;
            } else {
                this.$router.push({
                    path: "/tankBookStock/index",
                    query: {
                        id: row.id,
                        pageStatus: 1,
                    },
                });
                sessionStorage.setItem("pageStatus", 1);
                return;
            }

        },
        async handleViewPdf(id) {
            const response = await generateHoldingCertPdf(id);
            const blob = new Blob([response], { type: 'application/pdf' });
            const fileURL = window.URL.createObjectURL(blob);
            this.holdingCertUrl = fileURL;
            this.pdfDialogVisible = true;
            this.showPdfView = true;
        },

        resetForm() {
            this.createForm = {
                tank: "",
                tankFarm: "",
                product: "",
                gov: "",
                gsv: "",
                metricTon: "",
                bbl: "",
                density: "",
                temp: "",
                customers: [
                    { companyName: "" }
                ]
            };
        },
        addCustomer() {
            this.createForm.customers.push({ companyName: "" });
        },
        removeCustomer(index) {
            this.createForm.customers.splice(index, 1);
        },

        async exportToExcel() {
            try {
                var params = {}

                if (this.selectTank) {
                    params = { ...params, tank: this.selectTank }
                }
                if (this.selectCustomer) {
                    params = { ...params, customer: this.selectCustomer }
                }
                if (this.selectProduct) {
                    params = { ...params, product: this.selectProduct }
                }

                const res = await exportExcel(params);

                const blob = new Blob([res], { type: "application/vnd.ms-excel" });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.download = `TankInventoryBookStock_${new Date().toISOString().slice(0, 10)}.xlsx`
                link.href = url;
                link.click();
                URL.revokeObjectURL(url);

                this.$message.success("Excel file exported successfully!");
            } catch (error) {
                console.error(error);
                this.$message.error("Failed to export Excel file");
            }


        },
        onTankDropdownVisible(visible) {
            if (!visible || this.userInfo.userType === '2') return;

            this.$nextTick(() => {
                const dropdowns = document.querySelectorAll('.el-select-dropdown .el-select-dropdown__wrap');
                const dropdown = dropdowns[dropdowns.length - 1];
                if (!dropdown) return;

                dropdown.removeEventListener('scroll', this.handleTankScroll);
                dropdown.addEventListener('scroll', this.handleTankScroll);
            });
        },

        async handleTankScroll(event) {
            const dropdown = event.target;
            const reachBottom = dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 5;

            if (!reachBottom || this.tankLoading) return;
            if (this.tankList.length >= this.tankTotal) return;

            this.tankPageParams.pageNum += 1;
            await this.loadTankList(false);
        },
        importFromExcel() {
            const input = document.createElement('input');
            input.type = 'file';
            input.multiple = false;
            input.accept = '.xlsx, .xls';

            input.addEventListener('change', async (event) => {
                const file = event.target.files[0];
                if (!file) return;

                if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                    this.$message.error('Please select a valid Excel file');
                    return;
                }

                const formData = new FormData();
                formData.append('file', file);

                try {
                    const response = await importBookStockExcel(formData);

                    if (response.code === 200) {
                        this.$message.success('Excel file imported successfully');

                    }
                } catch (error) {
                    console.error('Error importing Excel file:', error);
                    if (error.data && Array.isArray(error.data)) {
                        let baseOffset = 100;
                        let currentOffset = baseOffset;

                        error.data.forEach(errItem => {

                            const charCount = errItem.length;

                            const charsPerLine = 31;
                            const lineCount = Math.ceil(charCount / charsPerLine);
                            const estimatedHeight = lineCount * 24 + 30;

                            this.$notify.error({
                                title: errItem,
                                duration: 0,
                                showClose: true,
                                offset: currentOffset
                            });

                            currentOffset += estimatedHeight;
                        });
                    }
                    this.$message.error(error.message || 'Failed to import Excel file');
                } finally {
                    this.getList();
                }
            });

            input.click();
        },
        resetTankList() {
            this.tankList = [];
            this.tankTotal = 0;
            this.tankPageParams.pageNum = 1;
        },
        async loadTankList(reset = false) {
            if (this.userInfo.userType === '2') {
                const res = await formTankselect();
                if (res.code === 200 && Array.isArray(res.data)) {
                    this.tankList = res.data.map(item => ({
                        label: item.tankName,
                        value: item.tankName,
                    }));
                    this.tankTotal = this.tankList.length;
                } else {
                    this.tankList = [];
                    this.tankTotal = 0;
                }
                return;
            }

            if (reset) {
                this.tankPageParams.pageNum = 1;
                this.tankList = [];
                this.tankTotal = 0;
            }

            this.tankLoading = true;
            try {
                const res = await getTanksList({
                    pageNum: this.tankPageParams.pageNum,
                    pageSize: this.tankPageParams.pageSize,
                });

                if (res.code === 200 && Array.isArray(res.rows)) {
                    const newTanks = res.rows.map(item => ({
                        label: item.tankName,
                        value: item.tankName,
                    }));

                    if (reset) {
                        this.tankList = newTanks;
                    } else {
                        const existing = new Set(this.tankList.map(t => t.value));
                        const filtered = newTanks.filter(t => !existing.has(t.value));
                        this.tankList.push(...filtered);
                    }

                    this.tankTotal = res.total || 0;
                }
            } catch (err) {
                console.error('Error loading tanks:', err);
            } finally {
                this.tankLoading = false;
            }
        },
    }
};
</script>

<style scoped lang="scss">
.Topinp {
    position: relative;
}

.Topinput {
    display: flex;
    position: absolute;
    top: -65px;
    right: -40px;

    .Comipt {
        width: 275px;
        height: 46px;
    }

    .Pendingselect {
        width: 221px;
        height: 46px;
        margin-left: 16px;
    }
}

.Reqcol {
    display: flex;
    justify-content: center;
    height: calc(90vh - 80px - 32 * 2px - 56px);
    overflow-y: scroll;

    .ReqTable {
        width: 1000px;
    }

    .el-button--default {
        color: #fff;
        background-color: #008CDB;
    }

    .el-button--default.is-plain:hover {
        color: #fff;
        background: #008CDB;
        border-color: #008CDB;
    }

    .el-button--default:focus {
        color: #fff !important;
        background: #008CDB !important;
        border-color: #008CDB;
    }
}

::v-deep {
    .el-input__icon.el-icon-search {
        height: 32px !important;
    }
}

::v-deep .pagination-container {
    background: #f2f7fa;
}

::v-deep .el-input__suffix-inner {
    padding-right: 5px;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;

    svg {
        width: 13px;
        height: 13px;
        cursor: pointer;
    }
}

::v-deep .pagination-container {
    padding: 5px 0 5px 0;
}

::v-deep .Comtable .el-table div {
    word-break: break-word !important;
}

@media (max-width: 1023px) {
    .Comtable {
        height: calc(100vh - 175px);
    }

    .mobile-view {
        .Comtable {
            height: calc(100vh - 115px);
        }
    }
}

@media (min-width: 1024px) {
    .Comtable {
        height: calc(100vh - 180px);
    }
}

.el-button--default {
    color: #fff;
    background-color: #008CDB;
}

.el-button--default.is-plain:hover {
    color: #fff;
    background: #008CDB;
    border-color: #008CDB;
}

.el-button--default:focus {
    color: #fff !important;
    background: #008CDB !important;
    border-color: #008CDB;
}

.Cbnbtn {
    text-align: right;
    /* margin-top: 38px; */
    /* padding-right: 36px; */
    /* padding-right: 2rem; */
}
</style>